import * as Yup from 'yup';

import { Strings } from '@app/constants';

// ----------------Add Assets----------------
export const addAssetSchema = Yup.object()
  .shape({
    assetName: Yup.string().required(Strings.validation.fieldRequired(Strings.assets.assetName)),
    otherAssetName: Yup.string()
      .trim()
      .nullable()
      .test(
        'is-assetName',
        Strings.validation.fieldRequired(Strings.assets.assetName),
        function (value) {
          const assetName = this.parent.assetName;
          if (assetName === 'other') {
            return !!value;
          }
          return true;
        }
      ),
    manufacturer: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.assets.manufacturer)),
    purchaseDate: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.assets.purchaseDate)),
    cost: Yup.string().trim().required(Strings.validation.fieldRequired(Strings.assets.cost)),
    vendor: Yup.string()
      .transform((value) => (typeof value === 'string' ? value.trim() : String(value).trim()))
      .required(Strings.validation.selectRequired(Strings.assets.vendor)),
    warranty: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.assets.warranty)),
    serialNumber: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.assets.serialNumber)),
    condition: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.assets.condition)),
    status: Yup.string().required(Strings.validation.selectRequired(Strings.assets.status)),
    assetsImage: Yup.string().required(
      Strings.validation.uploadRequired(Strings.assets.assetsImage)
    ),
  })
  .required();

export const addRepairSchema = Yup.object()
  .shape({
    repairPart: Yup.string().required(
      Strings.validation.fieldRequired(Strings.assets.manufacturer)
    ),
    status: Yup.string().required(Strings.validation.selectRequired(Strings.assets.status)),
  })
  .required();
